import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as channel from '../../config/constants/channel';
import PhoneMask from '../../masks-and-validators/phone';
import { useChannelMutation } from '../../hooks/use-channel-mutation';
import { useAppMode } from '../../hooks/use-app-mode';
import ChannelConfirmationContainer from './channel-confirmation-container';
import { colors, SMSIcon, InputText } from '@aftersale-next/ui';
import { useChannelSelection } from '../../hooks/use-channel-selection';
import { useUserInfo } from '../../hooks/use-user-info';
export default function SMSConfirmation() {
  var customerPhone = useUserInfo('sms');

  var _useState = useState(''),
      phone = _useState[0],
      setPhone = _useState[1];

  var error = !PhoneMask.validate(phone);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useAppMode = useAppMode(),
      _useAppMode2 = _slicedToArray(_useAppMode, 2),
      setMode = _useAppMode2[1];

  var _useChannelSelection = useChannelSelection(),
      _useChannelSelection2 = _slicedToArray(_useChannelSelection, 2),
      setSelected = _useChannelSelection2[1];

  var mutation = useChannelMutation({
    onSuccess: function onSuccess() {
      setMode('tracking');
      setSelected('');
    }
  });

  var handlePhoneChange = function handlePhoneChange(newPhone) {
    setPhone(newPhone);
  };

  var handleConfirm = function handleConfirm() {
    if (phone && PhoneMask.validate(phone)) {
      mutation.mutate({
        channel: channel.SMS,
        data: {
          phone: "55".concat(phone)
        }
      });
    }
  };

  useEffect(function () {
    setPhone(customerPhone);
  }, [customerPhone]);
  return /*#__PURE__*/_jsx(ChannelConfirmationContainer, {
    name: "sms",
    isDisabled: mutation.isLoading || error,
    handleConfirm: handleConfirm,
    label: t('TEXT_MESSAGE'),
    isLoading: mutation.isLoading,
    icon: /*#__PURE__*/_jsx(SMSIcon, {
      background: colors.textForeground
    }),
    children: /*#__PURE__*/_jsx(InputText, {
      id: "sms-input",
      name: "sms-input",
      label: t('CELL_PHONE_WITH_DDD'),
      placeholder: t('CELL_PHONE_WITH_DDD_PLACEHOLDER'),
      value: phone,
      onChange: handlePhoneChange,
      maxLength: 11,
      format: PhoneMask.maskWithoutCountry,
      unformat: PhoneMask.unmask,
      error: error
    })
  });
}